export default "__VITE_ASSET__CBJ5BVuc__"